if (!customElements.get('responsive-video')) {
  customElements.define('responsive-video', class ResponsiveVideo extends HTMLElement {
    constructor() {
      super();

      this.videoEl = this.querySelector('video');
      this.sourcesNodeList = this.videoEl.querySelectorAll('source');

      this.sourcesNodeList.forEach(sourceEl => {
        const mediaQueryString = sourceEl.getAttribute('media');

        let mediaQueryList = matchMedia(mediaQueryString);

        this.renderVideo({ mediaQueryList, sourceEl });

        mediaQueryList.addEventListener('change', (mediaQueryList) => {
          this.renderVideo({ mediaQueryList, sourceEl });
        });
      });
    }

    renderVideo({ mediaQueryList, sourceEl }) {
      const { matches } = mediaQueryList;

      if(matches) {
        const videoSrc = sourceEl.dataset.src;
        sourceEl.setAttribute('src', videoSrc);
        this.videoEl.load();
      } else {
        sourceEl.removeAttribute('src');
        this.videoEl.load();
      }
    }
  });
}
